import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { UserLevel } from '~/components/UserLevel/UserLevel'
import { ButtonPrimary } from '~/components/Buttons'

import { QuizFailedProps } from './QuizProps.models'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '275px' }]
const QuizFailedScreen: FC<QuizFailedProps> = ({
  totalQuestion = 0,
  onQuit,
  correctAnswer = 0,
}): React.ReactElement => {
  const { t } = useTranslation('bootcampQuiz')

  return (
    <div className="flex-1 flex flex-col justify-between items-center text-white px-5 py-7 w-full h-full bg-purple-gdark rounded-b">
      <div className="flex justify-center relative mt-1">
        <ResponsiveImage
          alt="failed banner"
          height={60}
          imageWidths="275"
          mediaQuery={mediaQuery}
          srcKey="bootcamp/defeated-banner.png"
          width={275}
        />
        <span className="absolute text-lg font-bold mt-0.5">{t('defeat')}</span>
      </div>
      <div className="flex flex-1 flex-col items-center justify-evenly">
        <span className="text-3xl font-semibold text-center">
          {t('no_of_correct_answers')} {correctAnswer}/{totalQuestion}
        </span>
        <p className="text-xl font-semibold text-center">{t('TryDefeatBoss')}</p>
        <UserLevel
          dividingLineColor="border-white"
          textSize={{ name: 'text-xl', title: 'text-sm' }}
          xpBarBG="bg-white"
          xpBarColor="bg-green"
        />
      </div>
      <ButtonPrimary className="ring-white text-lg z-20" onClick={onQuit} size="small" type="submit">
        {t('try_again!')}
      </ButtonPrimary>
    </div>
  )
}

export default QuizFailedScreen
